const initialize = () => {
  const form = document.querySelector("#gform_22");
  if (!form || form.dataset.lintrkBound === "true") return;

  hookLinkedInTracking(form);
};

document.addEventListener("DOMContentLoaded", initialize);
document.addEventListener("gform/postRender", initialize);

if (window.jQuery) {
  window.jQuery(document).on("gform_post_render", initialize);
}

const handleSubmission = () => {
  if (!window.lintrk || typeof window.lintrk !== "function") return;
  window.lintrk("track", { conversion_id: 23986905 });
};

const hookLinkedInTracking = (form) => {
  form.addEventListener("submit", handleSubmission);
  form.dataset.lintrkBound = "true";
};
